import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faClose } from "@fortawesome/free-solid-svg-icons";
import "./style.scss";

function Tag({ remove, key, item }) {
	return (
		<div
			className="tag border-primary border rounded p-2 mr-2"
			key={key}
		>
			{item}

			<FontAwesomeIcon
				icon={faClose}
				onClick={remove}
				className="cursor-pointer text-primary ml-2 text-sm"
			/>
		</div>
	);
}

export default Tag;
